<input
    type="hidden"
    [name]="name"
    [value]="control.value !== undefined ? control.value : ''"
    [attr.data-identifier]="identifier" />
<div
    #container
    tabindex="0"
    role="combobox"
    aria-haspopup="listbox"
    [attr.aria-expanded]="(opened$ | async) === true"
    [attr.aria-controls]="id + '-listbox'"
    class="sir-select-container"
    (focusin)="onFocus()"
    (focusout)="onBlur($event, container)"
    (click)="onClick($event)"
    (keydown.enter)="onClick($event); $event.preventDefault()"
    (keydown.space)="onClick($event); $event.preventDefault()"
    (keydown.escape)="onEscape()"
    [ngClass]="{
        'has-value': control.value,
        'is-invalid': (valid$ | async) === false,
        'is-focused': focused,
    }">
    <div class="sir-select-field">
        <div class="sir-select-text">
            <div
                [class]="labelClass">
                {{ label }}
                @if (validationService.isRequired(control)) {
                    <span class="sir-required-asterisk" aria-hidden="true">*</span>
                }
            </div>
            <div class="sir-select-value">
                {{ selectedOption?.text }}
            </div>
        </div>
        @if (opened$ | async) {
            <sirius-icon name="caret_up"></sirius-icon>
        } @else {
            <sirius-icon name="caret_down"></sirius-icon>
        }
    </div>
    @if (opened$ | async) {
        <div class="sir-select-tab-mask">
            <div class="sir-select-tab-mask-line"></div>
            <div class="sir-select-search"></div>
        </div>
        <div class="sir-select-tab-mask">
            <div class="sir-select-tab-mask-line"></div>
            <div class="sir-select-search"></div>
        </div>
        <ul class="sir-select-options" role="listbox" [id]="id + '-listbox'">
            @if (options.length >= 15) {
                <li class="sir-select-search" role="presentation">
                    <sirius-search
                        (valueChange)="filterOptions($event)"
                        (click)="$event.stopPropagation()"
                        [filterItems]="optionTexts"></sirius-search>
                </li>
            }
            @for (opt of filteredOptions$ | async; track $index) {
                <li role="presentation">
                    <button
                        type="button"
                        class="sir-select-option"
                        role="option"
                        [attr.aria-selected]="control.value === opt.value"
                        (click)="setValue(opt)"
                        [ngClass]="{
                            'is-selected': control.value === opt.value,
                        }">
                        <span class="sir-select-option-text">
                            {{ opt.text }}
                        </span>
                    </button>
                </li>
            }
        </ul>
    }
</div>
